import { PromoQuizBlockProps } from '@design-system/promo-quiz-block';

import { headingBlockMapper } from '~/mappers/headingBlock';
import { pageBlockUIMapper } from '~/mappers/pageBlock';

import { PromoForm } from './models';

const quizMapper = ({ quizId }: { quizId: string }): PromoQuizBlockProps => ({
  url: process.env.GATSBY_PROMO_PLATFORM_QUIZ_URL || '',
  quizId,
});

export const promoQuizMapper = (
  { pageBlockUI, componentId, heading, quiz, uid }: PromoForm,
  _id,
  externalData: { itemListingGrids?: unknown }
) => ({
  pageBlockUI: pageBlockUI && pageBlockUIMapper(pageBlockUI[0].ui),
  componentId,
  heading: headingBlockMapper(heading),
  quiz: quizMapper(quiz),
  uid,
  itemListingGrids: externalData.itemListingGrids,
});
